<ion-content>
  <div class="px-4 py-2 padding-bottom-configuration">
    <app-header-configuration
      [title]="'P0003607.installation.parametrage' | translate"
      [description]="
        'P0003607.installation.parametrage.description' | translate
      "
    >
    </app-header-configuration>

    <app-switch-configuration
      [title]="'P0003607.reglage.hivernage' | translate"
      [nameCustom]="'P0003607.reglage.activationfct' | translate"
      [value]="actionStack!.getValue('esPActivationFonctionHivernage') !== 0"
      [information]="EnSavoirPlusPage"
      (onPress)="
        this.actionStack!.editValue(
          P00039DataRxTxIndex.ElectrolyseurStandard_Parametrage,
          'esPActivationFonctionHivernage',
          $event ? 1 : 0,
          null
        )
      "
    >
    </app-switch-configuration>

    @if (actionStack!.getValue('esPActivationFonctionHivernage') === 1) {
      <app-label-configuration
        [titleListe]="'P0003607.reglage.seuilTemp' | translate"
        [value]="actionStack!.getValue('esPTemperatureHivernage')"
        [liste]="P0003607TemperatureHivernage()"
        (onPress)="
          this.actionStack!.editValue(
            P00039DataRxTxIndex.ElectrolyseurStandard_Parametrage2,
            'esPTemperatureHivernage',
            $event,
            null
          )
        "
      >
      </app-label-configuration>
    }

    <app-label-description
      [description]="'P0003607.reglage.hivernage.description' | translate"
    ></app-label-description>

    @if (showPositionModal()) {
      <app-information-title
        [title]="'P0003607.parametre.sourcereference' | translate"
      ></app-information-title>

      <div class="my-3">
        <app-affichage-warning
          icon="fa-regular fa-exclamation-circle"
          [name]="'configuration.presentationmiseenservice.warning' | translate"
        ></app-affichage-warning>
      </div>

      <app-larged-link
        [name]="'P0003607.configuration.sourceDebut' | translate"
        (onPress)="openPositionModal()"
      ></app-larged-link>

      <app-label-description
        [description]="
          'P0003607.parametre.sourcereference.description' | translate
        "
      ></app-label-description>
    }
  </div>
</ion-content>

<div class="position-absolute start-0 end-0 bottom-0 bg-white px-4 py-2">
  <div class="row">
    <div class="col-6 text-start">
      <ion-button
        color="medium"
        expand="block"
        fill="outline"
        class="mb-3"
        (click)="this.prev()"
      >
        {{ 'generic.retour' | translate }}
      </ion-button>
    </div>
    <div class="col-6 text-end">
      <ion-button color="primary" expand="block" (click)="onSubmit()">
        {{ 'generic.next' | translate }}
      </ion-button>
    </div>
  </div>
</div>
